import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  postPaymentSubscriptionRoute,
  errorMessage,
  currentPlanKey,
  addPaymentInformationRoute,
  paymentMethodsKey,
  paymentDetails,
} from '@features/payments';
import axiosInstance from '@server/axiosInstance';

type useAddPaymentMethodProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useAddPaymentMethod = ({
  setErrorText = () => { },
  onSuccess = () => { },
}: useAddPaymentMethodProps) => {
  const client = useQueryClient();

  const { mutate: addPaymentMethod, isLoading: isAddingPaymentMethod } =
    useMutation({
      mutationFn: (variables: { token: string; company_id?: number }) =>
        axiosInstance
          .post(addPaymentInformationRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          onSuccess();
          client.invalidateQueries([currentPlanKey]);
          client.invalidateQueries([paymentMethodsKey]);
          client.invalidateQueries([paymentDetails]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    addPaymentMethod,
    isAddingPaymentMethod,
  };
};
